import React, {useCallback, useEffect} from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    Button,
    ModalBody,
    ModalFooter
} from '@chakra-ui/react'
import no_internet from '../no_internet.svg';
import yes_internet from '../success.svg'
import styles from './Popup.css'

function Popup(props) {
    //This component show result of process

    return (
        <Modal isOpen={props?.isOpen} onClose={props?.onClose}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>{props?.popupData?.title || 'Titolo'}</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <p>{props?.popupData?.message || 'Messaggio'}</p>
                    {
                        props?.popupData?.status == true ?
                            <div className='image_container'>
                                <img className='pop_image' src={yes_internet} alt="Connessione riuscita"/>
                            </div>
                            :
                            <div className='image_container'>
                                <img className='pop_image' src={no_internet} alt="Nessuna connessione"/>
                            </div>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme='blue' mr={3} onClick={props?.onClose}>
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default Popup;
